import * as Constants from "../common/Constants";

const initialState = {
    employeeRoles: [],
    employeeRole:null,
    isLoading: false,
    isPosting: false,
    isPosted: false,
    count: 0,
    page: 1,
    pageSize: 10,
    isDuplicateRole: false,
    error: null,
    
};

export default function employeeRoleReducer(state = initialState, action) {

    switch (action.type) {

        case Constants.REQUEST_UPDATE_EMPLOYEE_ROLE:
        case Constants.REQUEST_ADD_EMPLOYEE_ROLE:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;

        case Constants.SUCCESS_UPDATE_EMPLOYEE_ROLE:
        case Constants.SUCCESS_ADD_EMPLOYEE_ROLE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            return newState;

        case Constants.FAILED_UPDATE_EMPLOYEE_ROLE:
        case Constants.FAILED_ADD_EMPLOYEE_ROLE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = action.error;
            return newState;

        case Constants.REQUEST_GET_EMPLOYEE_ROLES:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            newState.isPosting = false;
            return newState;

        case Constants.SUCCESS_GET_EMPLOYEE_ROLES:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.employeeRoles = action.payload.items;
            newState.page = action.payload.page;
            newState.pageSize = action.payload.pageSize;
            newState.count = action.payload.totalCount;
            return newState;

        case Constants.FAILED_GET_EMPLOYEE_ROLES:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.REQUEST_GET_SINGLE_EMPLOYEE_ROLE:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            newState.isPosting = false;
            //newState.filteredUsers = action.filteredUsers;
            return newState;

        case Constants.SUCCESS_GET_SINGLE_EMPLOYEE_ROLE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.employeeRole = action.payload;
            return newState;

        case Constants.FAILED_GET_SINGLE_EMPLOYEE_ROLE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.REQUEST_CHECK_DUPLICATE_EMPLOYEE_ROLE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            return newState;
       
        case Constants.SUCCESS_CHECK_DUPLICATE_EMPLOYEE_ROLE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.isDuplicateRole = action.payload;
            return newState;

        case Constants.ERROR_CHECK_DUPLICATE_EMPLOYEE_ROLE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.RESET_SINGLE_EMPLOYEE_ROLE:
            var newState = { ...state };
            newState.employeeRole = null;
            return newState;

        //case Constants.SUCCESS_FILTERED_EMPLOYEE:
        //    var newState = { ...state };
        //    newState.isPosting = false;
        //    newState.isLoading = false;
        //    newState.error = null;
        //    newState.isPosted = false;
        //    newState.filteredEmployees = action.filteredUsers;
        //    return newState;

        //case Constants.REQUEST_ADD_TO_EMPLOYEE_ROLE:
        //    newState = { ...state };
        //    newState.isLoading = true;
        //    newState.isPosted = false;
        //    newState.error = null;
        //    return newState;

        //case Constants.SUCCESS_ADD_TO_EMPLOYEE_ROLE:
        //    var newState = { ...state };
        //    newState.isPosting = false;
        //    newState.error = null;
        //    newState.isPosted = true;
        //    return newState;

        //case Constants.FAILED_ADD_TO_EMPLOYEE_ROLE:
        //    var newState = { ...state };
        //    newState.isPosting = false;
        //    newState.isPosted = false;
        //    newState.error = action.error;
        //    return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/EmployeeRoleReducer.js